const dirtyClass = 'js-is_dirty'
const className = 'js-prevent_unsaved_changes'

export function getMessage() {
  return document.querySelector('.unpoly_wrapper').dataset.unsavedChangesWarning
}

export function shouldPreventUnsavedChanges() {
  const formsWithUnsavedChanges = Array.from(document.querySelectorAll(`form.${className}.${dirtyClass}`))
  // after a form gets submitted, it no longer gets marked as dirty
  // but if there are errors in the form, that means it wasn't really saved
  // and should still be treated as dirty
  // this will cause false-positives in one case - when submitting a form with no changes causes validation errors
  const formsWithErrors = [
    ...Array.from(document.querySelectorAll(`form.${className} .error_description`)),
    ...Array.from(document.querySelectorAll(`form.${className} .form_control__errors`)),
    ...Array.from(document.querySelectorAll(`form.${className} *[aria-invalid="true"]`))
  ].filter(errTag => {
    const isEmpty = errTag.innerText.trim().length === 0
    // works with display: none;
    const isHidden = errTag.getBoundingClientRect().height === 0
    return !isEmpty && !isHidden
  })

  return formsWithUnsavedChanges.length > 0 || formsWithErrors.length > 0
}

up.on('up:link:follow', 'a:not(.js-do_not_warn_on_leaving)', event => {
  if (shouldPreventUnsavedChanges() && !confirm(getMessage())) {
    event.preventDefault()
  }
})

function beforeUnloadHandler(e) {
  if (shouldPreventUnsavedChanges()) {
    e.preventDefault()
    e.returnValue = getMessage()
  }
}

up.compiler(`form.${className}`, function (form) {
  window.addEventListener('beforeunload', beforeUnloadHandler)

  return function () {
    window.removeEventListener('beforeunload', beforeUnloadHandler)
  }
})

function markAsDirty(form) {
  form.classList.add(dirtyClass)
}

function markAsNotDirty(form) {
  form.classList.remove(dirtyClass)
}

function doNotPreventUnsavedChanges(form) {
  form.classList.remove(className)
}

up.on('change keyup', `form.${className}`, (event, form) => {
  markAsDirty(form)
})

up.on('submit', `form.${dirtyClass}`, event => {
  // submitting a form without JS will cause a page unload so we have to remove feature before submitting
  // 'markAsNotDirty' is not enough here because non-dirty forms with errors also need to behave like dirty forms
  doNotPreventUnsavedChanges(event.target)
})

up.on('up:form:submit', `form.${dirtyClass}`, (event, form) => {
  markAsNotDirty(form)
})

export function cancelWarnWhenLeaving(form) {
  form.classList.remove(dirtyClass)
}
